<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      top="8vh"
      append-to-body
      title="选择治具"
      width="800px">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="tools"
        @select="selectTool"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="编码" prop="toolNo">
            <el-input v-model.trim="filter.toolNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="名称" prop="toolName">
            <el-input v-model.trim="filter.toolName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          toolNo: "",
          toolName: "",
        },
        columns: [
          {
            title: "编号",
            key: "toolNo",
            align: "center",
            width: 110,
          },
          {
            title: "名称",
            key: "toolName",
            minWidth: 200,
          },
          {
            title: "类型",
            key: "toolModel",
            width: 110,
            align: "center",
          },
          {
            title: "备注",
            key: "note",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            title: "治具类型",
            key: "toolTypeName",
            width: 120,
            tooltip: true,
            align: "cnter",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectTool(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
